export class OrganizationId {
  private constructor(readonly value: string) {}

  static of(value: OrganizationId | string): OrganizationId {
    if (value instanceof OrganizationId) {
      return value;
    }
    return new OrganizationId(value);
  }
}
